import gsap from 'gsap';

export const destroyAnimations = (
	elements,
	theAnimations,
	timelines,
	textInstances
) => {
	theAnimations?.forEach( ( animation ) => {
		animation.clips.forEach( ( clip ) => {
			let theTargets = [];
			if ( clip.target ) {
				theTargets = [];
				clip.target.forEach( ( ele ) => {
					const getTargets = gsap.utils.toArray( ele );
					theTargets = theTargets.concat( getTargets );
				} );
			} else if ( elements ) {
				theTargets = elements;
			}
			const propsArray = [];
			if ( clip.from ) {
				for ( const key in clip.from ) {
					if ( clip.from.hasOwnProperty( key ) ) {
						if ( ! propsArray.includes( key ) ) {
							propsArray.push( key );
						}
					}
				}
			}
			if ( clip.to ) {
				for ( const key in clip.to ) {
					if ( clip.to.hasOwnProperty( key ) ) {
						if ( ! propsArray.includes( key ) ) {
							propsArray.push( key );
						}
					}
				}
			}
			const clearProps = propsArray.join( ',' );
			gsap.killTweensOf( theTargets );
			gsap.set( theTargets, { clearProps } );
		} );
	} );
	textInstances?.forEach( ( item ) => {
		item?.forEach( ( subItem ) => {
			subItem?.textInstance?.forEach( ( instance ) => {
				instance.revert();
			} );
		} );
	} );
	timelines?.forEach( ( item ) => {
		item?.forEach( ( timeline ) => {
			timeline.timeline?.kill();
			timeline.timeline = null;
		} );
	} );
};
